<ng-container *ngIf="noticias">
  <div class="row columns-4">
    <ng-container *ngFor="let item of noticias; trackBy: trackByNoticia; let i = index">
      <article class="noticia" ngClass="{{ item?.colorFondo ? 'noticia-color' : '' }}" [ngStyle]="item?.colorFondo && { 'background-color': item?.colorFondo }">
        <a [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">
          <ng-container *ngIf="!(item?.portada_iframe === '1')">
            <div class="bloque_4_mobile_{{ i }}">
              <div style="position: relative; width: 100%">
                <ng-container *ngIf="item?.texto_etiqueta">
                  <div
                    class="etiqueta et-xs"
                    [ngClass]="item?.class_etiqueta"
                    [ngStyle]="{
                      color: item?.color_texto_etiqueta,
                      'background-color': item?.color_fondo_etiqueta,
                    }"
                  >
                    <span class="etiquetaTxt">{{ item?.texto_etiqueta }}</span>
                  </div>
                </ng-container>
                <app-skeleton-image [created]="item?.fechaCreacion" [size]="size" [src]="item?.urlGenerica" [lazy]="lazy" [aspectRatio]="'97 / 55'" [alt]="item?.tituloVideo" [pixelSrc]="item?.pixelPortadaSrc" [pixelAlt]="item?.pixelPortadaAlt"></app-skeleton-image>
                <ng-container *ngIf="item?.hasVideo">
                  <app-animacion-video style="top: 0" class="animacion-video" [videoCargando]="false" [click]="false"></app-animacion-video>
                </ng-container>
              </div>
              <ng-container *ngIf="item?.tituloInvisible == '0'">
                <h2 class="header-article">
                  <ng-container *ngIf="!item?.tituloVideoSecundario">
                    {{ item?.tituloVideo }}
                  </ng-container>
                  <ng-container *ngIf="item?.tituloVideoSecundario">
                    {{ item?.tituloVideoSecundario }}
                  </ng-container>
                </h2>
              </ng-container>
              <div #divNombre class="footer-article" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                <ng-container *ngIf="!item?.noticias_relacionadas">
                  <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && item?.firma_externa">
                    <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ item?.firma_externa }}</span>
                  </ng-container>

                  <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && !item?.firma_externa">
                    <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ item?.nombre_autor }}</span>
                  </ng-container>

                  <ng-container *ngIf="item?.nombre_agencia || item?.autor_anonimo == 1 || !item?.nombre_autor">
                    <ng-container && !item?.firma_externa>
                      <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ autorEmpresa }}</span>
                    </ng-container>
                  </ng-container>
                  <span *ngIf="showFecha" [ngStyle]="item?.colorFondo && { color: item?.colorFecha }">{{ formatDate(item?.fecha) | date: "dd/MM/yyyy" }}</span>
                </ng-container>
                <ng-container *ngIf="item?.noticias_relacionadas">
                  <ng-container *ngFor="let relacionada of item?.noticias_relacionadas; trackBy: trackByNoticia">
                    <div class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                      <a [routerLink]="['/noticias', relacionada.idVideo, relacionada.titulo_seo | kebabCase]">
                        {{ relacionada.titulo }}
                      </a>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
              <p class="description-article" [innerHTML]="item?.entradillaVideo" [ngStyle]="item?.colorEntradilla && { color: item?.colorEntradilla }"></p>
            </div>
          </ng-container>

          <ng-container *ngIf="item?.portada_iframe_url && item?.portada_iframe === '1'">
            <ng-container *ngIf="item?.tituloInvisible == '0'">
              <h2 class="header-article">
                <ng-container *ngIf="!item?.tituloVideoSecundario">
                  {{ item?.tituloVideo }}
                </ng-container>
                <ng-container *ngIf="item?.tituloVideoSecundario">
                  {{ item?.tituloVideoSecundario }}
                </ng-container>
              </h2>
            </ng-container>
            <iframe [src]="item?.portada_iframe_url | safeResourceUrl" width="100%" height="134" frameborder="0"></iframe>
          </ng-container>
        </a>
      </article>
    </ng-container>
  </div>
</ng-container>
